import { gql } from '@apollo/client';

export const FILTERED_BENEFICIARY_TYPES = gql`
  query FilteredBeneficiaryTypes($input: FilterBeneficiaryTypesInput) {
    getBeneficiaryTypes(input: $input) {
      id
      name
    }
  }
`;
